



















import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import {FtPdfmakeTransformerService} from '@/utils/ft-pdfmake-transformer.service';
import {Content, TCreatedPdf} from 'pdfmake/build/pdfmake';
import AmetrasPdfPageResizeWrapperTemplate from '@/fields/pdf/AmetrasPdfPageResizeWrapperTemplate.vue';
import {FtReplacementTokenService} from '@/utils/ft-replacement-token.service';


// Custom Events: save
@Component({
  name: 'dynamic-document-preview-template',
  components: {
    AmetrasPdfPageResizeWrapperTemplate
  }
})
export default class DynamicDocumentPreviewTemplate extends Vue {
  @Prop() templateUrl!: string;
  loading: boolean = false;
  pdf: BufferSource | null = null;

  mounted() {
    if (this.templateUrl) {
      this.loadPreview();
    }
  }

  @Watch('templateUrl') onTemplateUrlChanged(newValue: string, oldValue: string) {
    if (newValue !== oldValue) {
      this.loadPreview();
    }
  }

  loadPreview() {
    this.loading = true;
    this.pdf = null;
    HTTP_SERVICE_INSTANCE.getAxios().get<DisguiseDto.FTDefinitionDto>(
        this.templateUrl
    ).then((response) => {
      let documentHeader: Content[] | undefined;
      if (response.data.printConfig && response.data.printConfig.printHeader &&
          response.data.printConfig.printHeader.content) {
        documentHeader = JSON.parse(atob(response.data.printConfig.printHeader.content));
      }

      new FtReplacementTokenService().replace(response.data, {});

      new FtPdfmakeTransformerService(
          {
            getTableData: () => {
              return new Promise<DisguiseDto.DTTemplateDto>(() => undefined);
            }
          },
          {},
          48,
          ',',
          [0],
          ['00:00', '00:00:00']
      ).convertPartials([{
          formular: response.data,
          header: documentHeader
      }]).then((document: TCreatedPdf) => {
        this.loading = false;
        document.getBuffer((pdfBufferedStream: BufferSource) => {
          this.pdf = pdfBufferedStream;
        });
      }, () => {
        this.loading = false;
      });
    }, () => {
      this.loading = false;
    });
  }
}
